/* eslint-disable @typescript-eslint/no-explicit-any */
// https://github.com/Olian04/ts-callable-object/blob/master/src/index.ts

type keyType = string | number | symbol;

// eslint-disable-next-line @typescript-eslint/ban-types
export const callableObject = <F extends Function, T extends object>(
  func: F,
  draft: T
): F & T => <F & T>new Proxy(func, {
    get: (_, key: keyType) => (draft as any)[key],
    set: (_, key: keyType, value: any) => {
      (draft as any)[key] = value;
      return true;
    },
  });
